<template>
  <div class="signboard-page">
    <div class="container page">
      <div class="brick-layout">
        <BrickLayout :signboard="signboard" v-for="(signboard, index) in signboards" :key="index"></BrickLayout>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import BrickLayout from "../components/BrickLayout.vue";
export default {
  name: "Signboards",
  async beforeRouteEnter(to, from, next) {
    store.dispatch("fetchSignboards", to.params.slug);
    return next();
  },
  computed: {
    ...mapGetters(["signboards"]),
  },
  methods: {},
  components: {
    BrickLayout,
  },
};
</script>
